// Lightweight Meta Pixel wrapper — no-ops when pixel ID is missing.
let INITIALIZED = false;

export const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

export function initPixel() {
    if (INITIALIZED || !PIXEL_ID || typeof window === "undefined") return;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
    INITIALIZED = true;
}

export function pixelTrack(event, params = {}) {
    if (!PIXEL_ID || typeof window === "undefined" || !window.fbq) return;
    try { window.fbq("track", event, params); } catch { /* ignore */ }
}

// Standard Meta events we use across the app
export const PixelEvents = {
    lead: (source) => pixelTrack("Lead", { content_name: source }),
    initiateCheckout: (plan, value) => pixelTrack("InitiateCheckout", { content_name: plan, value, currency: "EUR" }),
    purchase: (plan, value) => pixelTrack("Purchase", { content_name: plan, value, currency: "EUR" }),
    viewContent: (name) => pixelTrack("ViewContent", { content_name: name }),
};
